







































import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import { ConstantMixin } from '../ConstantMixin'
import { OperationMixin } from '../OperationMixin'

function clone(obj) {
  return JSON.parse(JSON.stringify(obj))
}

@Component
export default class SensitiveWords extends Mixins(ConstantMixin, OperationMixin) {
  @Prop() public index!: number
  @Prop() public readonly!: boolean

  private get dataList() {
    return this.extraData.word_data.filter((item) => !!item.word_name)
  }

  private addItem() {
    this.extraData.word_data.push({
      word_name: '',
      sensitive_type: []
    })
  }

  private remove(index) {
    this.extraData.word_data.splice(index, 1)
  }

  private handleClose(word) {
    const index = this.extraData.word_data.indexOf(word)
    this.extraData.word_data.splice(index, 1)
  }
}
